const ESPService = {
  createWebSocket() {
    return new WebSocket("ws://localhost:8181")
  },

  createError(message) {
    return {
      response: {
        data: {
          status: 400,
          errors: [message],
        },
      },
    }
  },

  getCertThumbprint(certinfo) {
    if (!certinfo)
      return null
    if (Array.isArray(certinfo) && certinfo.length > 0)
      return certinfo[0].thumbprint
    if (typeof certinfo === "object" && Object.keys(certinfo).length > 0)
      return certinfo.thumbprint
    return null
  },

  createSignRequest(data, certThumb) {
    return {
      function: "cryptoSign",
      obj: `${data}`,
      cms: false,
      detached: false,
      cert_thumb: `${certThumb}`,
      cert_sn: "",
      pin: "",
    }
  },

  // 🧠 Bitta sign (bir ma'lumot uchun)
  signedData(data) {
    return new Promise((resolve, reject) => {
      const ws = this.createWebSocket()

      ws.onopen = () => {
        ws.send(JSON.stringify({ function: "getCertInfo" }))
      }

      ws.onmessage = (evt) => {
        try {
          const response = JSON.parse(evt.data)

          if (response.status !== "success") {
            reject(this.createError("ESP operatsiya muvaffaqiyatsiz"))
            ws.close()
            return
          }

          // Agar sign natijasi keldi
          if (!response.certinfo) {
            resolve({ data: response })
            ws.close()
            return
          }

          const certThumb = this.getCertThumbprint(response.certinfo)
          if (!certThumb) {
            reject(this.createError("Certificate topilmadi"))
            ws.close()
            return
          }

          const signRequest = this.createSignRequest(data, certThumb)
          ws.send(JSON.stringify(signRequest))
        } catch {
          reject(this.createError("ESP ключ не найден"))
          ws.close()
        }
      }

      ws.onerror = () => {
        reject(this.createError("Не установлены необходимые программы для ключа ESP"))
        ws.close()
      }
    })
  },

  // ⚙️ Ko‘p ma’lumotlarni sign qilish (refaktoring qilingan, sequential tarzda)
  async signedDataMultiple(dataArray) {
    if (!Array.isArray(dataArray) || dataArray.length === 0)
      throw this.createError("Sign qilish uchun ma'lumot yo‘q")

    const ws = this.createWebSocket()

    return new Promise((resolve, reject) => {
      let certThumb = ""
      const signedDatas = []
      let isCertFetched = false
      let currentIndex = 0

      ws.onopen = () => {
        console.log("ESP WebSocket ochildi")
        ws.send(JSON.stringify({ function: "getCertInfo" }))
      }

      ws.onmessage = async (evt) => {
        try {
          const response = JSON.parse(evt.data)

          if (response.status !== "success") {
            reject(ESPService.createError("ESP operatsiya muvaffaqiyatsiz"))
            ws.close()
            return
          }

          // ✅ Dastlab certificate olish
          if (!isCertFetched && response.certinfo) {
            isCertFetched = true
            certThumb = ESPService.getCertThumbprint(response.certinfo) || ""
            if (!certThumb) {
              reject(ESPService.createError("Certificate topilmadi"))
              ws.close()
              return
            }
            // Birinchi signni yuboramiz
            const signRequest = ESPService.createSignRequest(dataArray[currentIndex], certThumb)
            ws.send(JSON.stringify(signRequest))
            return
          }

          // ✅ Sign natijasi keldi
          if (response.signedMsg) {
            signedDatas.push(response.signedMsg)
            currentIndex++

            // Agar barcha ma’lumotlar sign bo‘lsa
            if (currentIndex >= dataArray.length) {
              resolve({ data: signedDatas })
              ws.close()
              return
            }

            // Keyingi sign so‘rov yuborish
            const nextSign = ESPService.createSignRequest(
              dataArray[currentIndex],
              certThumb,
            )
            ws.send(JSON.stringify(nextSign))
          }
        } catch {
          reject(ESPService.createError("ESP ключ не найден"))
          ws.close()
        }
      }

      ws.onerror = () => {
        reject(ESPService.createError("Не установлены необходимые программы для ключа ESP"))
        ws.close()
      }
    })
  },
}

export default ESPService
